import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  redirectUrl: '',

  // edit carrier
  editCarrierCoverImage: '',

  // new task added
  tasks: {
    newTaskAdded: false,
    newAssignedTaskAdded: false,
    newAlarmIncoming: false,
    newNotificationIncoming: false,
  },
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setRedirectUrl: (state, action: PayloadAction<string>) => {
      state.redirectUrl = action.payload;
    },
    setEditCarrierCoverImage: (state, action: PayloadAction<string>) => {
      state.editCarrierCoverImage = action.payload;
    },
    setNewTaskAdded: (state, action: PayloadAction<boolean>) => {
      state.tasks.newTaskAdded = action.payload;
    },
    setNewAssignedTaskAdded: (state, action: PayloadAction<boolean>) => {
      state.tasks.newAssignedTaskAdded = action.payload;
    },
    setNewAlarmIncoming: (state, action: PayloadAction<boolean>) => {
      state.tasks.newAlarmIncoming = action.payload;
    },
    setNewNotificationIncoming: (state, action: PayloadAction<boolean>) => {
      state.tasks.newNotificationIncoming = action.payload;
    },
    resetCommonSlice: () => initialState,
  },
});

export const commonActions = commonSlice.actions;

export const commonReducers = commonSlice.reducer;
